import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import RouteEffects from "./components/RouteEffects";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Experience from "./pages/Experience";
import About from "./pages/About";
import AltTabTheory from "./pages/AltTabTheory";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import "./App.css";

export function PortfolioContent() {
  const location = useLocation();
  return (
    <>
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <RouteEffects />
      <NavBar />
      <main id="main-content" tabIndex="-1" key={location.pathname}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/experience" element={<Experience />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:slug" element={<ProjectDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/alttabtheory" element={<AltTabTheory />} />
          <Route
            path="/gallery"
            element={<Navigate to="/about#photo-journal" replace />}
          />
          <Route path="/contact-me" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}
export default function App() {
  return (
    <BrowserRouter>
      <PortfolioContent />
    </BrowserRouter>
  );
}
